export const NAVIGATOR_USER_FALLBACK_NAME = "Usuário";
export const NAVIGATOR_USER_PANEL_LABEL = "Informações do usuário";
export const NAVIGATOR_USER_EDIT_HINT =
  "Para editar seus dados de acesso ao Hub, atualize sua conta no site da Microsoft.";
export const NAVIGATOR_USER_PHOTO_PATH = "/api/me/foto";
